import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import XIcon from '@mui/icons-material/X';
import { Box, Stack, Typography, useTheme } from '@mui/material';

export const ContactDetails = () => {
  const theme = useTheme();

  const socialIcons = [
    { icon: XIcon, key: 'x', url: 'https://x.com/changegps' },
    {
      icon: FacebookIcon,
      key: 'facebook',
      url: 'https://www.facebook.com/changegps',
    },
    {
      icon: LinkedInIcon,
      key: 'linkedin',
      url: 'https://www.linkedin.com/company/changegps/',
    },
  ];

  return (
    <Box sx={{ py: 1.5 }}>
      <Typography
        fontWeight={500}
        lineHeight={1.4}
        fontSize={16}
        pb={1.5}
        sx={{
          marginBottom: 1,
          color: 'text.primary',
        }}
      >
        Contact Details
      </Typography>
      <Stack spacing={2}>
        <Box sx={{ paddingLeft: 0.5 }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: 14,
              marginBottom: 0.75,
              color: 'text.primary',
            }}
          >
            Address
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: 13,
              lineHeight: 1.6,
              color: 'text.secondary',
            }}
          >
            Change GPS Pty Ltd
            <br />
            527/535 South Pine Road
            <br />
            EVERTON PARK Queensland 4053
          </Typography>
        </Box>

        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{ paddingLeft: 0.5 }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 18,
            }}
          >
            <PhoneIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
          </Box>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: 13,
              color: 'text.secondary',
            }}
          >
            1300 268 684
          </Typography>
        </Stack>

        <Stack
          direction="row"
          spacing={1.5}
          sx={{ paddingLeft: 0.5, paddingTop: 0.5 }}
        >
          {socialIcons.map(({ icon: Icon, key, url }) => (
            <Box
              key={key}
              component="a"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: theme.palette.horizonGreen2.main,
                padding: 0.75,
                borderRadius: 100,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 28,
                height: 28,
                textDecoration: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                '&:hover': {
                  backgroundColor: theme.palette.primary.main,
                  transform: 'translateY(-1px)',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                },
                '&:active': {
                  transform: 'translateY(0)',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                },
              }}
            >
              <Icon sx={{ color: 'white', fontSize: 15 }} />
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};
